import { Tooltip } from 'antd';
import { type CSSProperties } from 'styled-components';

import { StyledQuestionCircleOutlined } from './TooltipWithQuestionIcon.style';

export const TooltipWithQuestionIcon = ({
  message,
  iconStyle,
}: {
  message: JSX.Element | string;
  iconStyle?: CSSProperties;
}) => {
  return (
    <Tooltip style={{ margin: '0 0.5rem' }} title={message}>
      <StyledQuestionCircleOutlined style={iconStyle} />
    </Tooltip>
  );
};
